/**
 * Admin bookings list (read-only).
 *
 * Route: `/bookings`
 * Permission: `bookings:read` (super_admin + support + finance — content_moderator
 * is excluded per F16 Decision 13).
 *
 * The venue-detail "Bookings" tab (F42) embeds the SAME `AdminBookingsList`
 * component (scoped via `lockedVenueId`), so the table + filters + fetch logic
 * live in exactly one place — a fix here lands on both surfaces.
 *
 * Read-only: every row deep-links to the F17 booking detail page at
 * `/bookings/:id` (the only place admins act on a booking — force-transition).
 */
import { AdminBookingsList } from '../../components/bookings/AdminBookingsList';

export function AdminBookingsPage() {
  return (
    <div className="space-y-6" data-testid="admin-bookings-page">
      <AdminBookingsList />
    </div>
  );
}

export default AdminBookingsPage;
